<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="mx-6 mb-6 mt-8 flex h-2 flex-grow flex-col">
    <div class="flex h-11 items-center">
      <div
        data-cy="projectInfoTitle"
        class="text-s1 select-none text-2xl font-semibold"
        >{{ pageTitle }}
      </div>
    </div>

    <div class="bg-m0 mt-6 h-2 w-full flex-1 rounded shadow">
      <div class="h-full w-full overflow-y-auto">
        <ng-scrollbar
          [orientation]="'vertical'"
          [visibility]="'hover'"
          [appearance]="'compact'"
        >
          <div class="ml-32 mt-16 flex flex-row">
            <div class="flex flex-col text-base">
              <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                >Project Name</div
              >
              <!-- <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                >Remote Repo Type</div
              > -->
              <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                >Remote Repo Default Branch</div
              >
              <div
                *ngIf="project?.remoteType === remoteTypeGitClone"
                class="flex h-16 select-none items-center justify-end font-semibold"
                >Remote Repo Git Url</div
              >
              <div
                class="flex h-16 select-none items-center justify-end font-semibold"
                *ngIf="project?.remoteType === remoteTypeGitClone"
                >Remote Repo Deploy Public Key</div
              >
              <div class="flex items-center justify-end font-semibold"></div>
            </div>

            <div class="ml-6 flex flex-col">
              <div class="flex flex-row">
                <div
                  data-cy="projectInfoName"
                  class="flex h-16 max-w-xl items-center truncate text-base"
                  >{{ project?.name | capitalize }}</div
                >

                <div
                  class="ml-10 flex items-center"
                  tp="Admin role required"
                  [tpIsEnabled]="isAdmin === false"
                >
                  <button
                    data-cy="projectInfoEditNameButton"
                    class="select-none rounded border px-3 py-2 text-base leading-3 shadow-sm focus:outline-none"
                    [ngClass]="{
                      'border-s400 text-s500 hover:bg-s100': isAdmin === true,
                      'border-s300 text-s400 cursor-default': isAdmin === false
                    }"
                    [disabled]="isAdmin === false"
                    (click)="editName()"
                    >Edit</button
                  >
                </div>
              </div>

              <!-- <div
                data-cy="projectInfoRemoteType"
                class="flex h-16 max-w-xl items-center truncate text-base"
                >{{ project?.remoteType | capitalize }}</div
              > -->
              <div
                data-cy="projectInfoRemoteType"
                class="flex h-16 max-w-xl items-center truncate text-base"
                >{{ project?.defaultBranch }}</div
              >

              <div
                class="flex h-16 flex-row items-center"
                *ngIf="project?.remoteType === remoteTypeGitClone"
              >
                <div
                  class="flex"
                  tp="Admin role required"
                  [tpIsEnabled]="isAdmin === false"
                >
                  <button
                    data-cy="projectInfoShowValueButton"
                    class="w-[73px] select-none rounded border px-3 py-2 text-base leading-3 shadow-sm focus:outline-none"
                    [ngClass]="{
                      'border-s400 text-s500 hover:bg-s100': isAdmin === true,
                      'border-s300 text-s400 cursor-default': isAdmin === false
                    }"
                    [disabled]="isAdmin === false"
                    (click)="toggleShowGitUrl()"
                    >{{ isGitUrlVisible ? 'Hide' : 'Show' }}
                  </button>
                </div>

                <div
                  *ngIf="isGitUrlVisible === true"
                  data-cy="projectInfoGitUrl"
                  class="ml-5 flex max-w-xl items-center text-base"
                  style="word-break: break-all"
                >
                  {{ project?.gitUrl }}
                </div>
              </div>

              <div
                class="flex min-h-16 flex-row items-start pt-[18px]"
                *ngIf="project?.remoteType === remoteTypeGitClone"
              >
                <div
                  class="flex items-center"
                  tp="Admin role required"
                  [tpIsEnabled]="isAdmin === false"
                >
                  <button
                    data-cy="projectInfoShowValueButton"
                    class="w-[73px] select-none rounded border px-3 py-2 text-base leading-3 shadow-sm focus:outline-none"
                    [ngClass]="{
                      'border-s400 text-s500 hover:bg-s100': isAdmin === true,
                      'border-s300 text-s400 cursor-default': isAdmin === false
                    }"
                    [disabled]="isAdmin === false"
                    (click)="toggleShowPublicKey()"
                    >{{ isPublicKeyVisible ? 'Hide' : 'Show' }}
                  </button>
                </div>

                <div
                  *ngIf="isPublicKeyVisible === true"
                  data-cy="projectInfoPublicKey"
                  class="ml-5 flex max-w-xl items-center text-base"
                  style="word-break: break-all"
                >
                  {{ project?.publicKey }}
                </div>
              </div>

              <div
                class="mb-5 mt-[50px] flex items-center"
                tp="Admin role required"
                [tpIsEnabled]="isAdmin === false"
              >
                <button
                  data-cy="projectInfoDeleteProjectButton"
                  class="select-none rounded border px-5 py-3 text-base font-medium shadow-sm focus:outline-none"
                  [ngClass]="{
                    'text-s400 cursor-default': isAdmin === false,
                    'border-r1 text-r1': isAdmin === true
                  }"
                  (click)="deleteProject()"
                  [disabled]="isAdmin === false"
                  >Delete Project</button
                >
              </div>
            </div>
          </div>
        </ng-scrollbar>
      </div>
    </div>
  </div>
</div>

<div *ngIf="project$ | async"></div>
<div *ngIf="isAdmin$ | async"></div>
